<template>
<mdb-container>
   <CustomerHeatMap/>
</mdb-container>
</template>

<script>
import {
  mdbContainer,
} from "mdbvue";
import CustomerHeatMap from '../components/CustomerHeatMap.vue';


export default {
name: "CustomerLocations",
components: {
    mdbContainer,
    CustomerHeatMap
}
}
</script>
